import { Stack, Image, ImageFit, PrimaryButton, DefaultButton, ProgressIndicator, IStyleFunctionOrObject, SpinnerSize, Spinner, ISpinnerStyleProps, ISpinnerStyles, IconButton, DialogType, Dialog, DialogFooter, IModalProps, IDialogContentProps, ActionButton } from "@fluentui/react";

import SoSmartLogo from '../../../Assets/Images/logo-colori.png';
import { Breakpoint, BreakpointType, ContainerFluid, GetBreakpoint } from "../Container/ContainerFluid";
import { useBreakpoint, useScreenViewportByBreakpoint } from "../Container/ContainerStyles";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { SystemDataLoadingStatus } from "../../../Model/SystemModels";
import { Loader } from "../Loader/Loader";
import { contentStyles, footerContainerStyles, headerContainerStyles, progressBarStyles, lgSpinnerStyles, logoStyles, mdSpinnerStyles, mdLogoStyles, smSpinnerStyles, smLogoStyles, smDefaultButtonStyle, mdDefaultButtonStyle, lgDefaultButtonStyle, smPrimaryButtonStyle, mdPrimaryButtonStyle, lgPrimaryButtonStyle, smReversedDefaultButtonStyle, mdReversedDefaultButtonStyle, lgReversedDefaultButtonStyle, lgReversedPrimaryButtonStyle, mdReversedPrimaryButtonStyle, smReversedPrimaryButtonStyle, closeButtonStyle, lgLogoStyles, xlLogoStyles, xxlLogoStyles, smDialogTitleStyles, dialogTitleStyles, lgDialogTitleStyles, mdDialogTitleStyles, xlDialogTitleStyles, xxlDialogTitleStyles, smDialogDescriptionStyles, mdDialogDescriptionStyles, xlDialogDescriptionStyles, xxlDialogDescriptionStyles, dialogDescriptionStyles, lgDialogDescriptionStyles, dialogPrimaryButtonStyles, smDialogPrimaryButtonStyles, lgDialogPrimaryButtonStyles, xlDialogPrimaryButtonStyles, mdDialogPrimaryButtonStyles, xxlDialogPrimaryButtonStyles, dialogDefaultButtonStyles, lgDialogDefaultButtonStyles, mdDialogDefaultButtonStyles, smDialogDefaultButtonStyles, xlDialogDefaultButtonStyles, xxlDialogDefaultButtonStyles, rightContainerStyles, chatContainerStyles, chatInnerContainerStyles, lgPrimaryIconButtonStyle, mdPrimaryIconButtonStyle, smPrimaryIconButtonStyle, lgDefaultIconButtonStyle, mdDefaultIconButtonStyle, smDefaultIconButtonStyle, lgHelpButtonStyle, mdHelpButtonStyle, smHelpButtonStyle, xlHelpButtonStyle, xxlHelpButtonStyle, helpButtonStyle } from "./Styles/RegisterContainerStyles";
import { ApplicationLogEntry, ApplicationLogEntryType, ErrorResponse, LeadToLive, LeadToLiveStep, RegisterError, RegisterFieldErrors } from "../../../Model/CommonModel";
import { RegisterService } from "./Service/RegisterService";
import { MessageType, ToastService } from "../../../Core/Toast/ToastService";
import { useApplicationContext } from "../ApplicationContainer/ApplicationContainer";
import { CrmLostRiskLine } from "../LeadDashboard/LeadDashboard";
import { SoSmartMicrosoftLogin } from "./Service/RegisterLoginMicrosoft";
import { ISessionStateContext, SessionStateContext } from "../../../Core/State/SessionStateContext";
import { LeadLiveMode, LeadTrialExperience } from "../../../Model/PartnerModels";
import MediaQuery from "react-responsive";
import { Chatbot } from "../../Chatbot/Chatbot";
import { CommonOTPDialog, OTPStatus } from "../CommonOTPDialog/CommonOTPDialog";
import { RegisterHelpPopup } from "./Components/Common/RegisterHelpPopup";
import { CommonFunctions } from "../../../ApplicationCode/Common/CommonFunctions";

//#region Register Context Hook

export interface IRegisterContext {
    footerButtonProps: IRegisterFooterProps;
    leadToLive: LeadToLive;
    registerError: RegisterError;
    onNext: (currentLeadToLive? : LeadToLive) => void;
    onPreviews: () => void;
    setLeadToLive: (qualificationData: LeadToLive) => void;
    setValidationErrors: (errors: RegisterError) => void;
    setProgressBarHidden: (hidden: boolean) => void;
    setShowLoader: (showLoader: boolean, message: string) => void;
    setFooterButtonProps: (props: IRegisterFooterProps) => void;
}

export function useRegisterContext() {
    return useOutletContext<IRegisterContext>();
}

//#endregion

export const RegisterContainer: React.FC = () => {
    const [registerContext, setRegisterContext] = useState<IRegisterContext>({} as IRegisterContext);
    const [leadToLive, setLeadToLive] = useState<LeadToLive>(new LeadToLive());
    const [registerError, setRegisterError] = useState<RegisterError>(new RegisterError());
    const [canReloadData, setCanReloadData] = useState<boolean>(true);
    const [registerHelpPopupHidden, setRegisterHelpPopupHidden] = useState<boolean>(true);
    const [registerHelpPopupSaveInProgress, setRegisterHelpPopupInProgress] = useState<boolean>(false);
    const [otpDialogHidden, setOtpDialogHidden] = useState<boolean>(true);
    const [otpValidationInProgress, setOtpValidationInProgress] = useState<boolean>(false);
    const [optStatus, setOtpStatus] = useState<OTPStatus>(OTPStatus.Empty);
    const optValidatedRef = useRef<boolean>(false);
    const applicationContext = useApplicationContext();
    const sessionStateContext: ISessionStateContext = useContext(SessionStateContext);
    const location = useLocation();


    const [containerDataStatus, setContainerDataStatus] = useState<SystemDataLoadingStatus>(SystemDataLoadingStatus.ToLoad);
    const abortController = new AbortController();
    const navigate = useNavigate();

    const [breakpointxxl] = useState<Breakpoint>(GetBreakpoint(BreakpointType.xxl));
    const isXl = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);
    const isXXXL = useBreakpoint(BreakpointType.xxxl);
    const [progressBarHidden, setProgressBarHidden] = useState<boolean>(false);
    const [showLoaderSpinner, setShowLoaderSpinner] = useState<boolean>(false);
    const [loaderMessage, setLoaderMessage] = useState<string>("");
    const [dialogHidden, setDialogHidden] = useState<boolean>(true);
    const [dialogTitle, setDialogTitle] = useState<string>("");
    const [dialogDescription, setDialogDescription] = useState<string>("");
    const [dialogPrimaryButtonText, setDialogPrimaryButtonText] = useState<string>("");
    const [dialogDefaultButtonText, setDialogDefaultButtonText] = useState<string>("");
    const [footerProps, setFooterProps] = useState<IRegisterFooterProps>({
        backButtonHidden: false,
        nextButtonHidden: false,
        backButtonDisabled: false,
        nextButtonDisabled: false,
        nextButtonText: RegisterService.translate("wizardNextButton"),
        backButtonText: RegisterService.translate("wizardBackButton"),
        nextButtonIcon: "ChevronRight",
        backButtonIcon: "ChevronLeft",
        nextButtonReverseFlex: true,
        backButtonReverseFlex: false
    });


    //#region Context utility

    const onSaveLeadToLive = useCallback((leadToLive: LeadToLive) => {
        setLeadToLive(leadToLive);
    }, []);

    const onSetFooterProps = useCallback((props: IRegisterFooterProps) => {
        setFooterProps(props);
    }, []);

    const onSetRegisterContext = useCallback((context: IRegisterContext) => {
        setRegisterContext(context);
    }, []);

    const updateContextAndNavigate = (leadToLive: LeadToLive) => {
        //Update the context
        onSaveLeadToLive(leadToLive);
        onSetRegisterContext({...registerContext, leadToLive: leadToLive, registerError: new RegisterError()});

        //Remove the loader
        setShowLoader(false, "");

        //Navigate to the next step
        navigate(RegisterService.getStepEndpoint(leadToLive));
    }

    const onNextStep = (leadToLiveRef?: LeadToLive) => {
        let currentLeadToLive: LeadToLive = new LeadToLive();
        if(leadToLiveRef)
            currentLeadToLive = leadToLiveRef;
        else
            currentLeadToLive = leadToLive;

        switch(currentLeadToLive.currentStep) {
            case LeadToLiveStep.VAT:
                setCanReloadData(true);
                setShowLoader(true, RegisterService.translate("companyDataLoader"));

                RegisterService.validateAndGetVATData(currentLeadToLive).then((leadToLive: LeadToLive) => {
                    RegisterService.saveQualificationData(leadToLive, abortController.signal).then((savedLeadToLive: LeadToLive) => {
                        updateContextAndNavigate(savedLeadToLive);
                    })
                    .catch((error) => {
                        ToastService.showMessage(MessageType.Error, error.message);
                    });
                })
                .catch((error: ErrorResponse) => {
                    setError(currentLeadToLive, error.message, "vat");
                })
                break;
            case LeadToLiveStep.CompanyData:
                setCanReloadData(true);
                setShowLoader(true, RegisterService.translate("companyDataSaveLoader"));
                
                validateData(currentLeadToLive).then(() => {
                    currentLeadToLive.lead.companyDataValidated = true;
                    RegisterService.saveQualificationData(currentLeadToLive, abortController.signal).then((savedLeadToLive: LeadToLive) => {

                        currentLeadToLive = savedLeadToLive;
                        currentLeadToLive.currentStep = LeadToLiveStep.Welcome;
                        updateContextAndNavigate(currentLeadToLive);
                    })
                    .catch((error) => {
                        ToastService.showMessage(MessageType.Error, error.message);
                    });
                })
                break;
            case LeadToLiveStep.Welcome:
                setShowLoader(true, RegisterService.translate("companyDataLoader"));
                
                if(canReloadData){
                    RegisterService.getQualificationStatus(currentLeadToLive.currentStep, abortController.signal).then((qualificationStatus: LeadToLive) => {
                        setCanReloadData(false);

                        currentLeadToLive = qualificationStatus;
                        currentLeadToLive.leadToLiveQualificationDetails.businessNeedsRiskLines = initGoals(currentLeadToLive);
                        currentLeadToLive.currentStep = LeadToLiveStep.Goals;
                        updateContextAndNavigate(currentLeadToLive);
                    })
                    .catch((error) => {
                        ToastService.showMessage(MessageType.Error, error.message);
                    });
                }
                else{
                    currentLeadToLive.currentStep = LeadToLiveStep.Goals;
                    updateContextAndNavigate(currentLeadToLive);
                    setShowLoader(false, "");
                }
                break;
            case LeadToLiveStep.Goals:
                setShowLoader(true, RegisterService.translate("configurationLoader"));
                validateData(currentLeadToLive).then(() => {
                    RegisterService.saveQualificationData(leadToLive, abortController.signal).then((savedLeadToLive: LeadToLive) => {
                        currentLeadToLive.currentStep = LeadToLiveStep.Configuration;
                        updateContextAndNavigate(currentLeadToLive);
                    })
                    .catch((error) => {
                        ToastService.showMessage(MessageType.Error, error.message);
                    });
                });
                break;
            case LeadToLiveStep.Configuration:
                setShowLoader(true, RegisterService.translate("configurationLoader"));

                window.setTimeout(() => {
                    validateData(currentLeadToLive).then(() => {
                        RegisterService.saveQualificationData(leadToLive, abortController.signal).then((savedLeadToLive: LeadToLive) => {
                            currentLeadToLive.currentStep = LeadToLiveStep.Migrations;
                            updateContextAndNavigate(currentLeadToLive);
                        })
                        .catch((error) => {
                            ToastService.showMessage(MessageType.Error, error.message);
                        });
                    });
                }, 500);
                break;
            case LeadToLiveStep.Migrations:
                setShowLoader(true, RegisterService.translate("configurationLoader"));
                RegisterService.saveQualificationData(leadToLive, abortController.signal).then((savedLeadToLive: LeadToLive) => {
                    currentLeadToLive.currentStep = LeadToLiveStep.Scenario;
                    updateContextAndNavigate(currentLeadToLive);
                })
                .catch((error) => {
                    ToastService.showMessage(MessageType.Error, error.message);
                });
                break;
            case LeadToLiveStep.Scenario:
                setShowLoader(true, RegisterService.translate("configurationLoader"));

                window.setTimeout(() => {
                    validateData(currentLeadToLive).then(() => {
                        RegisterService.saveQualificationData(leadToLive, abortController.signal).then((savedLeadToLive: LeadToLive) => {
                            currentLeadToLive.currentStep = LeadToLiveStep.TrialEvaluation;
                            updateContextAndNavigate(currentLeadToLive);
                        })
                        .catch((error) => {
                            ToastService.showMessage(MessageType.Error, error.message);
                        });
                    });
                }, 500);
                break;
            case LeadToLiveStep.TrialEvaluation:
                setShowLoader(true, RegisterService.translate("configurationLoader"));
                
                window.setTimeout(() => {
                    validateData(currentLeadToLive).then(() => {
                        RegisterService.saveQualificationData(currentLeadToLive, abortController.signal).then((savedLeadToLive: LeadToLive) => {
        
                            //Get the trial status
                            RegisterService.getTrialStatus(currentLeadToLive.currentStep, abortController.signal).then((savedTrial: LeadToLive) => {
                                currentLeadToLive = savedTrial;
                                updateContextAndNavigate(currentLeadToLive);
                            })
                            .catch((error) => {
                                ToastService.showMessage(MessageType.Error, error.message);
                            });
                        })
                        .catch((error) => {
                            ToastService.showMessage(MessageType.Error, error.message);
                        });
                    });
                }, 500);
                break;
            case LeadToLiveStep.TenantMode:
                if(!optValidatedRef.current) {
                    RegisterService.generateOtp();
                    setOtpDialogHidden(false);
                }
                else {
                    setShowLoader(true, RegisterService.translate("newTenantLoader"));
    
                    RegisterService.saveTrialData(currentLeadToLive, abortController.signal).then((savedTrial: LeadToLive) => {
                        setShowLoader(false, "");
                        setContainerDataStatus(SystemDataLoadingStatus.ToLoad);
                    })
                    .catch((error) => {
                        setShowLoader(false, "");
                        ToastService.showMessage(MessageType.Error, error.message);
                        setContainerDataStatus(SystemDataLoadingStatus.ToLoad);
                    });
                }
                break;
            case LeadToLiveStep.CspCustomerActive:
                SoSmartMicrosoftLogin.changePrivateUserToMsUser(sessionStateContext, navigate, currentLeadToLive);
                break;
            case LeadToLiveStep.CSPReseller:
                setShowLoader(true, RegisterService.translate("tenantLoader"));

                RegisterService.saveTrialData(currentLeadToLive, abortController.signal).then((savedTrial: LeadToLive) => {
                    currentLeadToLive = savedTrial;
                    updateContextAndNavigate(currentLeadToLive);
                })
                .catch((error) => {
                    setShowLoader(false, "");
                    ToastService.showMessage(MessageType.Error, error.message);
                });
                break;
            case LeadToLiveStep.GDAPAdmin:
                setShowLoader(true, RegisterService.translate("authorizationLoader"));

                RegisterService.saveTrialData(currentLeadToLive, abortController.signal).then((savedTrial: LeadToLive) => {
                    currentLeadToLive = savedTrial;
                    updateContextAndNavigate(currentLeadToLive);
                })
                .catch((error) => {
                    setShowLoader(false, "");
                    ToastService.showMessage(MessageType.Warning, error.message);
                });
                break;
            case LeadToLiveStep.GDAPDyn365:
                setShowLoader(true, RegisterService.translate("authorizationLoader"));

                RegisterService.saveTrialData(currentLeadToLive, abortController.signal).then((savedTrial: LeadToLive) => {
                    currentLeadToLive = savedTrial;
                    updateContextAndNavigate(currentLeadToLive);
                })
                .catch((error) => {
                    setShowLoader(false, "");
                    ToastService.showMessage(MessageType.Warning, error.message);
                });
                break;
        }
    }

    const onPreviewsStep = () => {
        let currentLeadToLive: LeadToLive = leadToLive;

        switch(currentLeadToLive.currentStep){
            case LeadToLiveStep.CspCustomerActive:
            case LeadToLiveStep.CSPReseller:
            case LeadToLiveStep.GDAPAdmin:
            case LeadToLiveStep.GDAPDyn365:
                showConfirmDialog(
                    false, 
                    RegisterService.translate("confirmDialogTitle"), 
                    RegisterService.translate("confirmDialogDescription"),
                    RegisterService.translate("confirmPrimaryButton"), 
                    RegisterService.translate("confirmDefaultButton")
                );
                break;
            default:
                switch(currentLeadToLive.currentStep) {
                    case LeadToLiveStep.TenantMode:
                        setShowLoader(true, RegisterService.translate("companyDataLoader"));
                        
                        RegisterService.getQualificationStatus(currentLeadToLive.currentStep, abortController.signal).then((qualificationStatus: LeadToLive) => {
                            currentLeadToLive = qualificationStatus;
                            currentLeadToLive.currentStep = currentLeadToLive.currentStep - 1;
                            updateContextAndNavigate(currentLeadToLive);
                        })
                        .catch((error) => {
                            ToastService.showMessage(MessageType.Error, error.message);
                        });
                        break;
                    case LeadToLiveStep.Configuration:
                        currentLeadToLive.currentStep = LeadToLiveStep.Goals;
                        currentLeadToLive.leadToLiveQualificationDetails.businessNeedsRiskLines = initGoals(currentLeadToLive);
                        updateContextAndNavigate(currentLeadToLive);
                        break;
                    default:
                        currentLeadToLive.currentStep = currentLeadToLive.currentStep - 1;
                        updateContextAndNavigate(currentLeadToLive);
                        break;
                }
                break;
        }
    }

    const onRequestHelp = () => {
        setRegisterHelpPopupInProgress(true);

        let applicationLogEntry: ApplicationLogEntry = new ApplicationLogEntry();
        applicationLogEntry.type = ApplicationLogEntryType.Information;
        applicationLogEntry.source = "TRIALWIZARD";
        applicationLogEntry.message = `A lead requests help, details: Id: ${leadToLive.lead.id}, Company: ${leadToLive.lead.companyName}, Email: ${leadToLive.lead.email}, Phone: ${leadToLive.lead.phone}, Wizard step URL: ${window.location.href}`;
        applicationLogEntry.userId = sessionStateContext.currentUser.userId;

        RegisterService.requestHelp(applicationLogEntry).then(() => {
            setRegisterHelpPopupInProgress(false);
            setRegisterHelpPopupHidden(true);
        })
        .catch((error) => {
            ToastService.showMessage(MessageType.Error, error.message);
        });
        
    };

    const setShowLoader = (showLoader: boolean, message?: string) => {
        onSetFooterProps({...footerProps, nextButtonDisabled: showLoader, backButtonDisabled: showLoader, nextButtonHidden: false, backButtonHidden: false});
        setLoaderMessage(message!);
        setShowLoaderSpinner(showLoader);
    }

    const initContext = (leadToLive: LeadToLive) => {
        //Set the current step
        leadToLive.currentStep = RegisterService.getCurrentStep(leadToLive);
        setLeadToLive(leadToLive);

        //Initialize the context
        onSetRegisterContext(
            {
                footerButtonProps: footerProps,
                leadToLive: leadToLive,
                registerError: registerError,
                setShowLoader: setShowLoader,
                onNext: onNextStep,
                onPreviews: onPreviewsStep,
                setLeadToLive: onSaveLeadToLive,
                setValidationErrors: setRegisterError,
                setProgressBarHidden: setProgressBarHidden,
                setFooterButtonProps: onSetFooterProps,
            }
        );

        //Navigate to the current step
        navigate(RegisterService.getStepEndpoint(leadToLive));
    }

    useEffect(() => {
        applicationContext.setFullScreen(true);
    }, []);
    
    useEffect(() => {
        CommonFunctions.logSystemEvent("Customer navigation", "User navigate on page "+location.pathname, 0, sessionStateContext.currentUser.userId, "ACCESS", "NAVIGATE", location.pathname);
    }, [location.pathname])

    useEffect(() => {
        if(!applicationContext.fullScreen)
            return;

        if(containerDataStatus === SystemDataLoadingStatus.ToLoad) {
            setContainerDataStatus(SystemDataLoadingStatus.Loading);

            //Get the qualification status
            RegisterService.getQualificationStatus(LeadToLiveStep.None, abortController.signal).then((qualificationStatus) => {
                //Handle the step to show
                let currentLeadToLive: LeadToLive = qualificationStatus;

                if(currentLeadToLive.lead.setupCompanyCompleted) {
                    //Get the trial status
                    RegisterService.getTrialStatus(LeadToLiveStep.None, abortController.signal).then((trialStatus: LeadToLive) => {
                        currentLeadToLive = trialStatus;
                        initContext(currentLeadToLive);

                        setContainerDataStatus(SystemDataLoadingStatus.Loaded);
                    })
                    .catch((error) => {
                        ToastService.showMessage(MessageType.Error, error.message);
                    });
                }
                else {
                    initContext(currentLeadToLive);
                    setContainerDataStatus(SystemDataLoadingStatus.Loaded);
                }
            })
            .catch((error) => {
                ToastService.showMessage(MessageType.Error, error.message);
            });

        }
    }, [containerDataStatus])

    //#endregion

    //#region Error handling

    const setError = (leadToLive: LeadToLive, error: string, fieldKey?: string) => {
        let errors: RegisterError = new RegisterError();
        errors.hasError = true;
        errors.step = leadToLive.currentStep;

        if(fieldKey) {
            let fieldError: RegisterFieldErrors = new RegisterFieldErrors();
            fieldError.key = fieldKey;
            fieldError.error = error;
            errors.fieldErrors.push(fieldError);
        }
        else {
            errors.errorMessage = error;
        }

        setRegisterError(errors);
        onSetRegisterContext({
            ...registerContext, 
            leadToLive: leadToLive, 
            registerError: errors
        });
        setShowLoader(false, "");
    };

    const setErrors = (leadToLive: LeadToLive, errors: RegisterError) => {
        setRegisterError(errors);
        onSetRegisterContext({
            ...registerContext, 
            leadToLive: leadToLive, 
            registerError: errors
        });
        setShowLoader(false, "");
    };

    const validateData = (leadToLive: LeadToLive): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            let registerError: RegisterError = new RegisterError();
            registerError.step = leadToLive.currentStep;

            switch(leadToLive.currentStep) {
                case LeadToLiveStep.CompanyData:
                    const requiredFields: string[] = ["firstname", "lastname", "companyName", "country", "address", "zipCode", "city", "county"];
                    const companyData: Record<string, any> = leadToLive.lead;

                    requiredFields.forEach((field: string, index: number, array: string[]) => {
                        if(!companyData[field]){
                            registerError.fieldErrors.push({key: field, error: RegisterService.translate("companyDataError")});
                        }
                    });
                    
                    if(registerError.fieldErrors.length > 0)
                        registerError.hasError = true;

                    break;
                case LeadToLiveStep.Goals:
                    let requiredGoals: CrmLostRiskLine[] | null = leadToLive.leadToLiveQualificationDetails.businessNeedsRiskLines;
                    if(requiredGoals){
                        let description: string  = requiredGoals[0].description;

                        if(!description){
                            registerError.hasError = true;
                            registerError.fieldErrors.push({key: "goals", error: RegisterService.translate("goalsError")});
                        }
                    }
                    break;
                case LeadToLiveStep.Configuration:
                    if(leadToLive.lead.full_Users_No <= 0){
                        registerError.hasError = true;
                        registerError.errorMessage = RegisterService.translate("configurationUserError");
                    }

                    //Check if the user has selected at least one app THE FIRST IS ALWAYS SELECTED
                    if(leadToLive.leadToLiveQualificationDetails.leadQuoteDetails.filter((app) => app.selected).length == 1) {
                        registerError.hasError = true;
                        registerError.errorMessage = RegisterService.translate("configurationAppError");
                    }
                    break;
                case LeadToLiveStep.Scenario:
                    if(leadToLive.lead.liveMode == LeadLiveMode.None) {
                        registerError.hasError = true;
                        registerError.errorMessage = RegisterService.translate("scenarioError");
                    }
                    break;
                case LeadToLiveStep.TrialEvaluation:
                    if(leadToLive.lead.trialExperience === LeadTrialExperience.None) {
                        registerError.hasError = true;
                        registerError.errorMessage = RegisterService.translate("trialEvaluationError");
                    }
                    break;
                
            }

            if(registerError.hasError){
                setErrors(leadToLive, registerError);
                reject();
            }
            else
                resolve();
        });
    }

    //#endregion Error handling

    //#region Utility

    const initGoals = (leadToLive: LeadToLive): CrmLostRiskLine[] => {
        //Initialize goals
        let businesssNeeds: CrmLostRiskLine[] = leadToLive.leadToLiveQualificationDetails.businessNeedsRiskLines;
        const businessNeedsInit: CrmLostRiskLine = {
            entryNo: 0, 
            lineScore: 0, 
            sourceId: 0, 
            sourceExternalId: 0,
            lossCauseCode: "BUSINESS_NEEDS", 
            lossCauseDescription: "", 
            description: "", 
            notes: '', 
            processCode: '', 
            processModule: '', 
            sourceTable: '',
        }
        
        const existingIds = new Set(businesssNeeds.map(bn => bn.sourceExternalId));

        const addIfMissing = (id: number) => {
            if (!existingIds.has(id)) {
                businesssNeeds.push({ ...businessNeedsInit, sourceExternalId: id });
                existingIds.add(id);
            }
        };

        addIfMissing(10000);
        addIfMissing(20000);
        addIfMissing(30000);
        
        return businesssNeeds.sort((a, b) => a.sourceExternalId - b.sourceExternalId);
    }

    const closeWizard = () => {
        if(abortController)
            abortController.abort();
        
        navigate("/app");
    }

    const showConfirmDialog = (hidden: boolean, title: string, description: string, primaryButtonText: string, defaultButtonText: string) => {
        setDialogHidden(hidden);
        setDialogTitle(title);
        setDialogDescription(description);
        setDialogPrimaryButtonText(primaryButtonText);
        setDialogDefaultButtonText(defaultButtonText);
    };

    const resetTrialStep = (leadToLive: LeadToLive) => {
        showConfirmDialog(true, "", "", "", "");
        setShowLoader(true, RegisterService.translate("resettingTrialStep"));
                
        RegisterService.resetTrialStep(leadToLive, abortController.signal).then((leadToLive) => {
            updateContextAndNavigate(leadToLive);
        })
        .catch((error) => {
            ToastService.showMessage(MessageType.Error, error.message);
        });
    }

    const handleOptValidation = (code: string) => {
        setOtpValidationInProgress(true);
        if(!code){
            setOtpStatus(OTPStatus.NotValid);
            setOtpValidationInProgress(false);
            return;
        }

        RegisterService.validateOtp(code).then((isValid: boolean) => {
            optValidatedRef.current = isValid;

            if(isValid)
            {
                setOtpStatus(OTPStatus.Valid);
                setOtpDialogHidden(true);
                onNextStep();
            }

            setOtpValidationInProgress(false);
        })
        .catch((err) => {
            setOtpStatus(OTPStatus.NotValid);
            setOtpValidationInProgress(false);
        });
    }

    const handleOptSendEmail = () => {
        RegisterService.generateOtp().then(() => {
            setOtpStatus(OTPStatus.ResendCode);
        })
        .catch(() => {
            setOtpStatus(OTPStatus.Empty);
        });
    }

    //#endregion Utility

    if(containerDataStatus !== SystemDataLoadingStatus.Loaded)
        return (
            <Loader text="" />
        )

    
    return (
        <Stack
            horizontal
            horizontalAlign="space-evenly"
            verticalAlign="center"
        >
            <ContainerFluid
                centered={!isXl && !isXXL && !isXXXL}
            >
                <RegisterHeader 
                    description={RegisterService.translate("stepDescription", {step: RegisterService.getStepNumber(leadToLive.currentStep), total: RegisterService.getTotalStepNumber()})}
                    label=""
                    percentComplete={RegisterService.getProgressPercentage(leadToLive.currentStep)}
                    closeButtonDisabled={showLoaderSpinner}
                    progressBarHidden={progressBarHidden}
                    onClose={() => closeWizard()}
                />
                <RegisterContent>
                    {
                        showLoaderSpinner ?
                            <RegisterLoader label={loaderMessage} />
                        :
                            <Outlet context={registerContext}/>
                    }
                </RegisterContent>
                <RegisterFooter
                    onNext={() => onNextStep()}
                    onPreviews={() => onPreviewsStep()}
                    onRequestHelp={() => setRegisterHelpPopupHidden(false)}
                    backButtonHidden={footerProps.backButtonHidden}
                    nextButtonHidden={footerProps.nextButtonHidden}
                    backButtonDisabled={footerProps.backButtonDisabled}
                    nextButtonDisabled={footerProps.nextButtonDisabled}
                    nextButtonText={footerProps.nextButtonText}
                    backButtonText={footerProps.backButtonText}
                    nextButtonIcon={footerProps.nextButtonIcon}
                    backButtonIcon={footerProps.backButtonIcon}
                    backButtonReverseFlex={footerProps.backButtonReverseFlex}
                    nextButtonReverseFlex={footerProps.nextButtonReverseFlex}
                />
                <RegisterConfirmDialog 
                    defaultButtonText={dialogDefaultButtonText}
                    primaryButtonText={dialogPrimaryButtonText}
                    title={dialogTitle}
                    description={dialogDescription}
                    hidden={dialogHidden}
                    onConfirm={() => {resetTrialStep(leadToLive)}}
                    onCancel={() => {setDialogHidden(true)}}
                />
            </ContainerFluid>
            <MediaQuery
                minWidth={breakpointxxl.minWidth}
            >
                <Stack
                    className={rightContainerStyles}
                >
                    <Chatbot
                        displayAppNavbar
                        hideChatbotNavbar
                        chatContainerStyles={chatContainerStyles}
                        chatInnerContainerStyles={chatInnerContainerStyles}
                        embedded
                    />
                </Stack>
            </MediaQuery>
            <CommonOTPDialog 
                hidden={otpDialogHidden}
                status={optStatus}
                validationInProgress={otpValidationInProgress}
                onValidateCode={(code: string) => {handleOptValidation(code)}}
                onResendCode={() => {handleOptSendEmail()}}
            />
            <RegisterHelpPopup 
                hidden={registerHelpPopupHidden}
                saveInProgress={registerHelpPopupSaveInProgress}
                onDismiss={() => {
                    setRegisterHelpPopupHidden(true);
                    setRegisterHelpPopupInProgress(false);
                }}
                onSuccess={() => onRequestHelp()}
            />
        </Stack>
    );
}

//#region Register header

interface IRegisterHeaderProps {
    label: string;
    description: string;
    percentComplete: number;
    progressBarHidden: boolean;
    closeButtonDisabled: boolean;
    onClose: () => void;
}

export const RegisterHeader: React.FC<IRegisterHeaderProps> = (props) => {
    return (            
        <Stack
            className={headerContainerStyles}
        >
            <RegisterCloseButton
                disabled={props.closeButtonDisabled}
                onClick={() => props.onClose()}
            />
            <RegisterLogo />
            <RegisterProgressBar 
                hidden={props.progressBarHidden}
                percentComplete={props.percentComplete}
                label={props.label}
                description={props.description}
            />
        </Stack>
    );
}

//#endregion

//#region Register logo

export const RegisterLogo: React.FC = (props) => {
    const breakpointType: BreakpointType = useScreenViewportByBreakpoint();

    const getImageStyles = (): string => {
        switch(breakpointType) {
            case BreakpointType.sm:
                return smLogoStyles;
            case BreakpointType.md:
                return mdLogoStyles;
            case BreakpointType.lg:
                return lgLogoStyles;
            case BreakpointType.xl:
                return xlLogoStyles;
            case BreakpointType.xxl:
                return xxlLogoStyles;
            default:
                return logoStyles;
        }
    }

    return (
        <Image className={getImageStyles()} src={SoSmartLogo} imageFit={ImageFit.cover} />
    );
}

//#endregion

//#region Register ProgressBar

export interface IRegisterProgressBarProps {
    hidden?: boolean;
    percentComplete: number;
    label: string;
    description: string;
}

export const RegisterProgressBar: React.FC<IRegisterProgressBarProps> = (props) => {

    return (
        <ProgressIndicator
            styles={progressBarStyles}
            label={props.label}
            description={props.description}
            percentComplete={props.percentComplete}
            progressHidden={props.hidden}
        />
    );
}

//#endregion

//#region Register Close Button

export interface IRegisterCloseButtonProps {
    disabled: boolean;
    onClick: () => void;
}

export const RegisterCloseButton: React.FC<IRegisterCloseButtonProps> = (props) => {

    return (
        <IconButton
            disabled={props.disabled}
            styles={closeButtonStyle}
            iconProps={{iconName: 'ChromeClose'}}
            onClick={() => props.onClick()}
        />
    );
}

//#endregion

//#region Register Content

export const RegisterContent: React.FC = (props) => {
    
    return (
        <Stack className={contentStyles}>
            {props.children}
        </Stack>
    );
};

//#endregion

//#region Register footer

export interface IRegisterFooterProps {
    onNext?: () => void
    onPreviews?: () => void;
    onRequestHelp?: () => void;
    nextButtonText: string;
    backButtonText: string;
    nextButtonIcon: string;
    backButtonIcon: string;
    backButtonReverseFlex: boolean;
    nextButtonReverseFlex: boolean;
    backButtonHidden: boolean;
    nextButtonHidden: boolean;
    backButtonDisabled: boolean;
    nextButtonDisabled: boolean;
}

export const RegisterFooter: React.FC<IRegisterFooterProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <Stack 
            className={footerContainerStyles} 
            horizontal
            verticalFill
            verticalAlign="center"
            horizontalAlign="space-between"
        >
            {
                props.backButtonHidden ?
                    <Stack></Stack>
                :
                    <>
                        {
                            isSM || isMD || isLG ?
                                <IconButton 
                                    iconProps={{iconName: props.backButtonIcon}}
                                    styles={
                                        isSM ? 
                                            smDefaultIconButtonStyle 
                                            : 
                                                isMD ? 
                                                    mdDefaultIconButtonStyle
                                                    : 
                                                    lgDefaultIconButtonStyle
                                    }
                                    onClick={() => props.onNext!()}
                                />
                            :
                                <DefaultButton 
                                    hidden={props.backButtonHidden}
                                    disabled={props.backButtonDisabled}
                                    iconProps={{ iconName: props.backButtonIcon }}
                                    styles={
                                        props.backButtonReverseFlex ? 
                                            isSM ? 
                                                smReversedDefaultButtonStyle 
                                                : 
                                                    isMD ? 
                                                        mdReversedDefaultButtonStyle 
                                                        : 
                                                        lgReversedDefaultButtonStyle 
                                                : 
                                            isSM ? 
                                                smDefaultButtonStyle 
                                                : 
                                                    isMD ? 
                                                        mdDefaultButtonStyle
                                                        : 
                                                        lgDefaultButtonStyle
                                    }
                                    onClick={() => props.onPreviews!()}
                                >
                                    {props.backButtonText}
                                </DefaultButton>
                        }
                    </>
            }
            <ActionButton
                iconProps={{iconName: "Telemarketer"}}
                styles={
                    isSM ? 
                        smHelpButtonStyle : 
                    isMD ? 
                        mdHelpButtonStyle : 
                    isLG ?
                        lgHelpButtonStyle :
                    isXL ?
                        xlHelpButtonStyle :
                    isXXL ?
                        xxlHelpButtonStyle 
                    :
                        helpButtonStyle
                }
                onClick={() => props.onRequestHelp!()}
            >
                {RegisterService.translate("helpButton")}
            </ActionButton>
            {
                props.nextButtonHidden ?
                    <Stack></Stack>
                :
                    <>
                        {
                            isSM || isMD || isLG ?
                                <IconButton 
                                    iconProps={{iconName: props.nextButtonIcon}}
                                    styles={
                                        isSM ? 
                                            smPrimaryIconButtonStyle 
                                            : 
                                                isMD ? 
                                                    mdPrimaryIconButtonStyle
                                                    : 
                                                    lgPrimaryIconButtonStyle
                                    }
                                    onClick={() => props.onNext!()}
                                />
                            :
                                <PrimaryButton
                                    hidden={props.nextButtonHidden}
                                    disabled={props.nextButtonDisabled}
                                    iconProps={{ iconName: props.nextButtonIcon }}
                                    styles={
                                        props.nextButtonReverseFlex ?
                                            isSM ? 
                                                smReversedPrimaryButtonStyle 
                                                : 
                                                    isMD ? 
                                                        mdReversedPrimaryButtonStyle
                                                        : 
                                                        lgReversedPrimaryButtonStyle
                                                :
                                            isSM ? 
                                                smPrimaryButtonStyle 
                                                : 
                                                    isMD ? 
                                                        mdPrimaryButtonStyle
                                                        : 
                                                        lgPrimaryButtonStyle
                                    }
                                    onClick={() => props.onNext!()}
                                >
                                    {props.nextButtonText}
                                </PrimaryButton>
                        }
                    </>
            }
        </Stack>
    );
};

//#endregion

//#region Register Loader

export interface IRegisterLoaderProps {
    label: string;
}

export const RegisterLoader: React.FC<IRegisterLoaderProps> = (props) => {
    const breakpointType: BreakpointType = useScreenViewportByBreakpoint();

    const getSpinnerStyles = (): IStyleFunctionOrObject<ISpinnerStyleProps, ISpinnerStyles> => {
        switch(breakpointType) {
            case BreakpointType.sm:
                return smSpinnerStyles;
            case BreakpointType.md:
                return mdSpinnerStyles;
            default:
                return lgSpinnerStyles;
        }
    }

    return (
        <Spinner styles={getSpinnerStyles()} size={SpinnerSize.large} label={props.label} />
    );
}

//#endregion


//#region Register Confirm Dialog

export interface IRegisterConfirmDialogProps {
    title: string;
    description: string;
    primaryButtonText: string;
    defaultButtonText: string;
    hidden: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const RegisterConfirmDialog: React.FC<IRegisterConfirmDialogProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    const dialogContentProps: IDialogContentProps = {
        type: DialogType.close,
        title: props.title,
        closeButtonAriaLabel: 'Close',
        subText: props.description,
        styles: {
            title : 
                isSM ? 
                    smDialogTitleStyles :
                isMD ?
                    mdDialogTitleStyles :
                isLG ?
                    lgDialogTitleStyles :
                isXL ?
                    xlDialogTitleStyles :
                isXXL ?
                    xxlDialogTitleStyles
                :
                    dialogTitleStyles,
            subText:
                isSM ?
                    smDialogDescriptionStyles :
                isMD ?
                    mdDialogDescriptionStyles :
                isLG ?
                    lgDialogDescriptionStyles :
                isXL ?
                    xlDialogDescriptionStyles :
                isXXL ?
                    xxlDialogDescriptionStyles
                :
                    dialogDescriptionStyles
            
        }
    };

    const modalProps: IModalProps = {
        titleAriaId: "dialogLabel",
        subtitleAriaId: "subTextId",
        isBlocking: false,
        dragOptions: undefined
    };

    return(
        <Dialog
            hidden={props.hidden}
            onDismiss={props.onCancel}
            dialogContentProps={dialogContentProps}
            modalProps={modalProps}
        >
            <DialogFooter>
                <PrimaryButton 
                    onClick={props.onConfirm} 
                    text={props.primaryButtonText}
                    styles={
                        isSM ?
                            smDialogPrimaryButtonStyles :
                        isMD ?
                            mdDialogPrimaryButtonStyles :
                        isLG ?
                            lgDialogPrimaryButtonStyles :
                        isXL ?
                            xlDialogPrimaryButtonStyles :
                        isXXL ?
                            xxlDialogPrimaryButtonStyles
                        :
                            dialogPrimaryButtonStyles
                    }
                />
                <DefaultButton 
                    onClick={props.onCancel} 
                    text={props.defaultButtonText} 
                    styles={
                        isSM ?
                            smDialogDefaultButtonStyles :
                        isMD ?
                            mdDialogDefaultButtonStyles :
                        isLG ?
                            lgDialogDefaultButtonStyles :
                        isXL ?
                            xlDialogDefaultButtonStyles :
                        isXXL ?
                            xxlDialogDefaultButtonStyles
                        :
                            dialogDefaultButtonStyles
                    }
                />
            </DialogFooter>
        </Dialog>
    );
}

//#endregion Register Confirm Dialog